import React from "react";

// Centered icon + title + subtitle block for "nothing here yet" states —
// replaces the ad-hoc `<div className="text-center text-gray-400 py-12">`
// copies scattered across every Agent Program screen.
export default function EmptyState({ icon: Icon, title, subtitle, compact = false }) {
  return (
    <div className={`flex flex-col items-center text-center ${compact ? "py-10" : "py-16"}`}>
      {Icon && (
        <div className={`rounded-full bg-gray-100 flex items-center justify-center mb-3 ${compact ? "h-12 w-12" : "h-16 w-16"}`}>
          <Icon size={compact ? 20 : 26} className="text-gray-400" />
        </div>
      )}
      {title && <p className="text-sm font-medium text-gray-600">{title}</p>}
      {subtitle && <p className="text-xs text-gray-400 mt-1 max-w-xs">{subtitle}</p>}
    </div>
  );
}
